export default __webpack_public_path__ + "static/media/binoculars.41e1bc35.da5476c1.svg";